import { render, staticRenderFns } from "./tariffIndex.vue?vue&type=template&id=f5887c16&scoped=true"
import script from "./tariffIndex.vue?vue&type=script&lang=js"
export * from "./tariffIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5887c16",
  null
  
)

export default component.exports